import React from 'react'
import './MobileView.scss'
const MobileView = ({children}) => {
  return (
    <div className='mobileView'>{children}</div>
  )
}

export default MobileView